"use client";

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "~/components/ui/tooltip";

import { useTrackLemmas } from "../../../state/lemmas/hooks/useTrackLemmas";

export default function WordCounts({
  lemmasCount,
  excludeKnownLemmasCount = false,
}: {
  lemmasCount: number;
  excludeKnownLemmasCount?: boolean;
}) {
  const { trackedLemmasCount } = useTrackLemmas();

  return (
    <div className="mb-4 flex items-center justify-between px-4">
      <Tooltip>
        <TooltipTrigger asChild>
          <div className="text-sm">
            {lemmasCount} words{" "}
            {!excludeKnownLemmasCount && trackedLemmasCount > 0 && (
              <span className="text-muted-foreground">
                ({trackedLemmasCount} known)
              </span>
            )}
          </div>
        </TooltipTrigger>
        <TooltipContent className="max-w-[150px] bg-primary text-primary-foreground">
          <p>
            These are counts of distinct words, even if they are repeated in
            various forms.
          </p>
        </TooltipContent>
      </Tooltip>
    </div>
  );
}
